import React from "react";
import { useNavigate } from "react-router-dom";
import TexCell from "../atom/TexCell";

const TableRow = ({ request, isSelected, onSelect }) => {
  const {
    requestId,
    createdAt,
    department,
    positionType,
    assigned,
    positionTitle,
    status,
  } = request;

  const navigate = useNavigate();

  const handleClick = () => {
    onSelect();
    navigate(`/requests/${requestId}`);
  };

  return (
    <tr
      className={`border-t cursor-pointer hover:bg-gray-50 ${
        isSelected ? "bg-gray-100" : ""
      }`}
      onClick={handleClick}
    >
      <td className="p-4" onClick={(e) => e.stopPropagation()}>
        <input
          type="radio"
          name="selectedRequest"
          checked={isSelected}
          onChange={onSelect}
        />
      </td>

      <TexCell text={requestId || "—"} />

      <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
        {createdAt && !isNaN(Date.parse(createdAt))
          ? new Date(createdAt).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "—"}
      </td>

      <TexCell text={department || "—"} />
      <TexCell text={positionType || "—"} />
      <TexCell text={assigned || "—"} />
      <TexCell text={positionTitle || "—"} />
      <TexCell text={status || "—"} />
    </tr>
  );
};

export default TableRow;
